import AOS from 'aos';
import { clearValidatorCustomError, hasValidatorCustomError, registerFormValidator, showValidatorCustomError } from './validator'
import './accordion'

window.TomSelect = require('../../public/js/lib/tom-select.complete.js')

require('./lib/tom-select')
require('./lib/popover')
require('./lib/gmaps')
require('./lib/filter')
require('./lib/banners_inter')

window.registerFormValidator = registerFormValidator
window.showValidatorCustomError = showValidatorCustomError
window.clearValidatorCustomError = clearValidatorCustomError
window.hasValidatorCustomError = hasValidatorCustomError

AOS.init();
